import { useEffect, useState } from 'react';
import { inlineEditBarMessages as messages } from './inline-edit-bar.messages';

/**
 * Rotating status copy while generating: opens with "thinking", walks
 * through the work, then alternates between the last two phrases so long
 * generations keep feeling alive rather than stuck. Edits and insights get
 * their own sequences.
 */
const EDIT_GENERATING_SEQUENCE = [
  messages.generating,
  messages.generatingReading,
  messages.generatingDrafting,
  messages.generatingPolishing,
] as const;
const INSIGHT_GENERATING_SEQUENCE = [
  messages.generating,
  messages.generatingReading,
  messages.generatingGathering,
  messages.generatingSummarising,
] as const;
const GENERATING_ROTATE_MS = 2000;

/** Pure step → message mapping used by the rotating generating label. */
export const resolveGeneratingLabel = (step: number, isInsight: boolean) => {
  const sequence = isInsight ? INSIGHT_GENERATING_SEQUENCE : EDIT_GENERATING_SEQUENCE;
  if (step < sequence.length) {
    return sequence[step]!;
  }
  // Keep alternating between the two "actively working" phrases afterwards.
  return step % 2 === 0 ? sequence[sequence.length - 1]! : sequence[sequence.length - 2]!;
};

export const useGeneratingLabel = (isGenerating: boolean, isInsight: boolean) => {
  const [step, setStep] = useState(0);

  useEffect(() => {
    if (!isGenerating) return;
    setStep(0);
    const timer = setInterval(
      () => setStep((current) => current + 1),
      GENERATING_ROTATE_MS
    );
    return () => clearInterval(timer);
  }, [isGenerating]);

  return resolveGeneratingLabel(step, isInsight);
};
